import { render } from "./DeliveryConfirmRedeem.vue?vue&type=template&id=3770cdc0"
import script from "./DeliveryConfirmRedeem.vue?vue&type=script&lang=js"
export * from "./DeliveryConfirmRedeem.vue?vue&type=script&lang=js"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__